module.exports = __webpack_public_path__ + "img/data-view-controls.a9fb4fbb.png";